// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-e825c012]{width:100%;text-align:center}.wrap img[data-v-e825c012]{margin-top:100px;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
